import { isNil } from "lodash/lang";

export const roundToDecimal = value => {
  const parsedValue = Number.parseFloat(value);

  return !isNil(value) && value !== "" && !isNaN(parsedValue)
    ? parsedValue.toFixed(2)
    : value;
};
